import axios from './axios';

export const fetchAllBadges = async () => {
    const response = await axios.get('/badges');
    return response.data;
};

export const fetchUserBadges = async (userID) => {
    const response = await axios.get(`/badges/user/${encodeURIComponent(userID)}`);
    return response.data;
};

// Full active badge catalog with earned-state merged in for the current authenticated user.
export const fetchMyBadges = async () => {
    const response = await axios.get('/badges/me');
    return response.data;
};

export const fetchBadgeCounts = async () => {
    const response = await axios.get('/badges/counts');
    return response.data;
};
